import { useLocation, useNavigate } from "react-router-dom";

const useNavigateWithQuery = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (to, options = {}) => {
    const currentSearchParams = new URLSearchParams(location.search);

    if (typeof to === "string") {
      navigate(`${to}?${currentSearchParams.toString()}`, options);
    } else if (typeof to === "object" && to.pathname) {
      const newSearchParams = new URLSearchParams(
        to.search || currentSearchParams
      );
      navigate({ ...to, search: `?${newSearchParams.toString()}` }, options);
    } else {
      navigate(to);
    }
  };
};

export default useNavigateWithQuery;
